import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Modal, ModalContentWrapper } from 'secondstep-components'
import ModalFooter from 'components/ModalFooter'

export const StyledModal = styled(Modal)`
  box-sizing: border-box;
  max-height: 100%;
  overflow: auto;
  font-family: ${themeGet('font.molde.regular')};

  ${ModalContentWrapper} {
    width: 650px;
    padding: 1.0625rem 1.375rem 0.8125rem;
  }
`

export const StyledModalFooter = styled(ModalFooter)`
  margin-top: 1.1875rem;
  margin-bottom: 0.4375rem;
`
